import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Modal, ModalBody } from "reactstrap";

const CancelModal = ({ show, onCancelClick, onCloseClick, order }) => {
  const [reason, setReason] = useState(null);
  const [message, setMessage] = useState("");

  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true}>
      <div className="modal-header">
        <h5 className="modal-title mt-0">Cancel and Refund</h5>
        <button
          onClick={onCloseClick}
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <ModalBody className="py-3 px-5">
        <div className="mt-2 ">
          <lord-icon
            src="https://cdn.lordicon.com/gsqxdxog.json"
            trigger="loop"
            colors="primary:#f7b84b,secondary:#f06548"
            style={{ width: "100px", height: "100px" }}
          ></lord-icon>
          <div className="mt-4 pt-2 fs-15">
            <p className="text-muted mb-0">
              <h5>If you cancel this order, the charges will be refunded.</h5>
            </p>
          </div>
          <br />
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn w-sm btn-light"
            data-bs-dismiss="modal"
            onClick={onCloseClick}
          >
            Close
          </button>
          <button
            type="button"
            className="btn w-sm btn-danger "
            id="send-record"
            onClick={() => {
              const data = {
                ord_id: order.ord_id,
                cancellation_reason: "0",
                cancellation_message: "",
                cancellation_reason_text: "User cancelation.",
              };
              onCancelClick(data)}} // This is the function that will be called when the button is clicked
          >
            Yes, Cancel it!
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

CancelModal.propTypes = {
  onCloseClick: PropTypes.func,
  onCancelClick: PropTypes.func,
  show: PropTypes.any,
};

export default CancelModal;
